<template>
  <div class="cardbox-bottom">
    <div class="collapsetitle">{{consignee.name}}</div>
    <div class="collapselist" v-if="isEmptyLR">
      {{ $t('PAY_LR_NOT_AVAILABLE') }}
    </div>
    <div v-else>
      <div class="row collapselist" v-for="(lorry_receipt,index) in consignee.lorry_receipts"
        :key="index">
        <div class="col">{{lorry_receipt.lr_number}}</div>
        <div class="col-md-auto collapselist-action">
          <div>
            <SwitchBtn style="display: block" v-model="lorry_receipt.document_available"
            active-text="Yes" inactive-text="No" @change="changeEvent($event,lorry_receipt)">
            </SwitchBtn>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="col-12 uploadsetion">
      <Attachments
        :attachments="getAttachments"
        :showPreview='true'
        :maxAllowed="lrAttachmentsLimit"
        :multiple=true
        @addAttachments="addAttachments"
        @removeAttachments="removeAttachments" />
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex';
import Attachments from '@common/components/Attachments';
import { LorryReceiptGenerationCategory } from 'pando-constants';


export default {
  props: ['consignee', 'indentID'],
  components: {
    Attachments,
  },
  data() {
    return {
      tempAttachments: [],
      newAttachments: [],
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/currentClientConfig',
    }),
    lrAttachmentsLimit() {
      return (this.configurations && this.configurations.attachments_limit &&
        this.configurations.attachments_limit.lr) ? this.configurations.attachments_limit.lr : 5;
    },
    getAttachments() {
      return this.consignee.attachments && this.consignee.attachments.map(attachment => ({ name: attachment.content_file_name,
        url: attachment.metadata.location,
        id: attachment._id,
      }));
    },
    isEmptyLR() {
      return !(this.consignee.lorry_receipts && this.consignee.lorry_receipts.length > 0);
    },
  },
  methods: {
    async addAttachments(file) {
      const formData = new FormData();
      formData.append('attachment', file.raw);
      const result = await this.$store.dispatch('paymentsV2/uploadDocument', formData);
      if (result) {
        const lorryReceipts = [{
          destination_id: this.consignee.consignee_id,
          source_location_id: this.consignee.depot_id,
          lr_attachment_ids: [result.id],
        }];
        if (this.configurations.multi_drop_at_gate_level) {
          lorryReceipts[0].gate_id = this.consignee.destination_gate_id;
        }
        const response = await this.$store.dispatch('paymentsV2/updateDocument', {
          orderNo: this.indentID, lorryReceipts });
        if (response.data) {
          const attachment = {
            content_file_name: result.name,
            _id: result.id,
            metadata: { location: result.attachment_url } };
          this.$emit('addLRAttachments', attachment);
        }
      } else {
        this.$error({ message: this.$getErr('UPLOAD_FAILS') });
      }
    },
    async removeAttachments(file) {
      const data = {
        indent_id: this.indentID,
        consignee_id: this.consignee.consignee_id,
        file_id: file.id,
      };
      await this.$store.dispatch('paymentsV2/removeAttachment', { data });
      this.$emit('removeLRAttachments', file.id);
      const lorryReceipts = this.consignee.lorry_receipts.reduce((acc, lr) => {
        const lorryReciept = lr;
        lorryReciept.destination_id = lr.destination_location_id;
        delete lorryReciept.destination_location_id;
        lorryReciept.document_available = !!this.consignee.attachments.length;
        acc.push(lorryReciept);
        return acc;
      }, []);
      const response = await this.$store.dispatch('paymentsV2/updateDocument', {
        orderNo: this.indentID, lorryReceipts });
    },
    changeEvent($event, lrNumber) {
      const recieptsResponse =
      {
        destination_id: this.consignee.consignee_id,
        source_location_id: this.consignee.depot_id,
        lr_number: lrNumber.lr_number,
        document_available: $event,
      };
      if (this.configurations.lorry_receipt_generate_category === LorryReceiptGenerationCategory.GATE_WISE) {
        recieptsResponse.source_gate_id = lrNumber.source_gate_id;
      }
      if (this.configurations.lorry_receipt_generate_category === LorryReceiptGenerationCategory.DIVISION_WISE) {
        recieptsResponse.divsion = lrNumber.divsion;
      }
      if (this.configurations.lorry_receipt_generate_category === LorryReceiptGenerationCategory.LEGAL_ENTITY_WISE) {
        recieptsResponse.legal_entity = lrNumber.legal_entity;
      }
      if (this.configurations.multi_drop_at_gate_level) {
        recieptsResponse.gate_id = this.consignee.destination_gate_id;
      }
      const lorryReceipts = [recieptsResponse];
      this.$emit('updateDocument', lorryReceipts);
    },
  },
};
</script>
